(function(){
  var t=document.getElementById('mobileMenuToggle'), d=document.getElementById('mobileDrawer');
  if(t&&d){
    function closeDrawer(){d.classList.remove('is-open');t.classList.remove('is-open');t.setAttribute('aria-expanded','false');document.body.classList.remove('drawer-open');}
    function openDrawer(){d.classList.add('is-open');t.classList.add('is-open');t.setAttribute('aria-expanded','true');document.body.classList.add('drawer-open');}
    t.addEventListener('click',function(){d.classList.contains('is-open')?closeDrawer():openDrawer();});
    d.querySelectorAll('[data-drawer-close]').forEach(function(el){el.addEventListener('click',closeDrawer);});
    d.querySelectorAll('.mobile-drawer-links a').forEach(function(a){a.addEventListener('click',closeDrawer);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});
  }

  document.querySelectorAll('.faq,.cc-item').forEach(function(d){var s=d.querySelector('summary');if(!s)return;s.setAttribute('aria-expanded','false');d.addEventListener('toggle',function(){s.setAttribute('aria-expanded',d.open?'true':'false');});});

  document.querySelectorAll('[data-slideshow]').forEach(function(ss){
    var slides=ss.querySelectorAll('.slide'), dots=ss.querySelectorAll('.slide-dot'), i=0, timer;
    if(slides.length<2)return;
    function show(n){slides[i].classList.remove('is-active');if(dots[i])dots[i].classList.remove('is-active');i=(n+slides.length)%slides.length;slides[i].classList.add('is-active');if(dots[i])dots[i].classList.add('is-active');}
    function next(){show(i+1);} function prev(){show(i-1);}
    function reset(){clearInterval(timer);start();}
    function start(){if(ss.dataset.autoplay==='true'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){timer=setInterval(next,parseInt(ss.dataset.speed,10)||6000);}}
    var prevBtn=ss.querySelector('.slide-arrow.prev'), nextBtn=ss.querySelector('.slide-arrow.next');
    if(prevBtn)prevBtn.addEventListener('click',function(){prev();reset();});
    if(nextBtn)nextBtn.addEventListener('click',function(){next();reset();});
    dots.forEach(function(dot,idx){dot.addEventListener('click',function(){show(idx);reset();});});
    ss.addEventListener('mouseenter',function(){clearInterval(timer);});
    ss.addEventListener('mouseleave',start);
    start();
  });

  document.querySelectorAll('[data-countdown]').forEach(function(cd){
    var end=Date.parse(cd.dataset.end); if(isNaN(end))return;
    var d=cd.querySelector('[data-cd-days]'),h=cd.querySelector('[data-cd-hours]'),m=cd.querySelector('[data-cd-mins]'),s=cd.querySelector('[data-cd-secs]');
    function pad(n){return String(n).padStart(2,'0');}
    function tick(){
      var diff=end-Date.now();
      if(diff<=0){clearInterval(timer);d.textContent=h.textContent=m.textContent=s.textContent='00';if(cd.dataset.hideOnComplete==='true'){cd.style.display='none';}return;}
      var days=Math.floor(diff/86400000),hours=Math.floor(diff%86400000/3600000),mins=Math.floor(diff%3600000/60000),secs=Math.floor(diff%60000/1000);
      d.textContent=pad(days);h.textContent=pad(hours);m.textContent=pad(mins);s.textContent=pad(secs);
    }
    var timer=setInterval(tick,1000); tick();
  });

  document.querySelectorAll('[data-recommendations]').forEach(function(el){
    var url=el.getAttribute('data-url'); if(!url)return;
    fetch(url).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var src=doc.querySelector('[data-recommendations-target]');
      var dst=el.querySelector('[data-recommendations-target]');
      if(src&&dst&&src.children.length){dst.innerHTML=src.innerHTML;el.style.display='';}
    }).catch(function(){});
  });

  var bar=document.getElementById('buybar'), hero=document.querySelector('.hero'), products=document.getElementById('products');
  if(bar&&hero&&products){
    function mob(){return window.matchMedia('(max-width:680px)').matches;}
    function onScroll(){if(!mob()){bar.classList.remove('show');return;}var ph=hero.getBoundingClientRect().bottom<0;var pr=products.getBoundingClientRect();var inp=pr.top<window.innerHeight&&pr.bottom>0;bar.classList.toggle('show',ph&&!inp);}
    window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll);onScroll();
  }

  var thumbsTrack=document.getElementById('thumbsTrack');
  if(thumbsTrack){
    var mainImg=document.getElementById('mainImg');
    var thumbItems=thumbsTrack.querySelectorAll('.thumb-item');
    thumbItems.forEach(function(t){
      t.addEventListener('click',function(){
        if(mainImg&&t.dataset.full)mainImg.src=t.dataset.full;
        thumbItems.forEach(function(o){o.classList.remove('is-active');});
        t.classList.add('is-active');
      });
    });
    var galleryPrev=document.querySelector('.gallery-arrow.prev'), galleryNext=document.querySelector('.gallery-arrow.next');
    function scrollThumbs(dir){thumbsTrack.scrollBy({left:dir*(thumbsTrack.clientWidth*0.8),behavior:'smooth'});}
    if(galleryPrev)galleryPrev.addEventListener('click',function(){scrollThumbs(-1);});
    if(galleryNext)galleryNext.addEventListener('click',function(){scrollThumbs(1);});
  }

  var qvModal=document.getElementById('quickViewModal'), qvBody=document.getElementById('quickViewBody');
  if(qvModal&&qvBody){
    function qvClose(){qvModal.hidden=true;document.body.style.overflow='';qvBody.innerHTML='';}
    function qvWire(){
      var form=qvBody.querySelector('.qv-form');
      if(!form)return;
      var variantSel=form.querySelector('.qv-variant'), priceEl=qvBody.querySelector('.qv-price'), status=form.querySelector('.qv-status');
      if(variantSel&&priceEl){
        variantSel.addEventListener('change',function(){
          var o=variantSel.options[variantSel.selectedIndex];
          if(o&&o.dataset.price)priceEl.firstChild.nodeValue=o.dataset.price;
        });
      }
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var fd=new FormData(form);
        fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
          .then(function(r){return r.json();})
          .then(function(data){
            if(status){status.hidden=false;status.textContent=data.status?(data.description||'Could not add to cart.'):'Added to cart.';}
            if(!data.status){
              var countEl=document.querySelector('.cart-link .count');
              if(countEl)countEl.textContent=(parseInt(countEl.textContent,10)||0)+ (parseInt(fd.get('quantity'),10)||1);
            }
          })
          .catch(function(){if(status){status.hidden=false;status.textContent='Could not add to cart.';}});
      });
    }
    document.addEventListener('click',function(e){
      var trigger=e.target.closest('[data-quick-view-url]');
      if(!trigger)return;
      e.preventDefault();
      var url=trigger.getAttribute('data-quick-view-url');
      qvBody.innerHTML='<p class="lede" style="padding:40px;text-align:center">Loading&hellip;</p>';
      qvModal.hidden=false;
      document.body.style.overflow='hidden';
      fetch(url).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var content=doc.querySelector('.qv-content');
        if(content){qvBody.innerHTML='';qvBody.appendChild(content);qvWire();}
        else{qvBody.innerHTML='<p class="lede" style="padding:40px;text-align:center">Could not load this product.</p>';}
      }).catch(function(){
        qvBody.innerHTML='<p class="lede" style="padding:40px;text-align:center">Could not load this product.</p>';
      });
    });
    qvModal.querySelectorAll('[data-qv-close]').forEach(function(el){el.addEventListener('click',qvClose);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!qvModal.hidden)qvClose();});
  }

  var bulkForm=document.querySelector('[data-bulk-order-form]');
  if(bulkForm){
    bulkForm.addEventListener('submit',function(e){
      e.preventDefault();
      var status=bulkForm.querySelector('.bo-status');
      var items=[];
      bulkForm.querySelectorAll('.bo-qty').forEach(function(input){
        var qty=parseInt(input.value,10);
        if(qty>0)items.push({id:parseInt(input.dataset.variantId,10),quantity:qty});
      });
      if(items.length===0){
        if(status){status.hidden=false;status.textContent='Enter a quantity for at least one item.';}
        return;
      }
      if(status){status.hidden=false;status.textContent='Adding to cart…';}
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();})
        .then(function(data){
          if(data.status){if(status)status.textContent=data.description||'Could not add items to cart.';return;}
          window.location.href='/cart';
        })
        .catch(function(){if(status)status.textContent='Could not add items to cart.';});
    });
  }

  function escHtml(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  var rvDataEl=document.getElementById('rvProductData'), rvCurrent=null;
  if(rvDataEl){
    try{
      rvCurrent=JSON.parse(rvDataEl.textContent);
      var rvList=JSON.parse(localStorage.getItem('recentlyViewed')||'[]');
      rvList=rvList.filter(function(p){return p.handle!==rvCurrent.handle;});
      rvList.unshift(rvCurrent);
      localStorage.setItem('recentlyViewed',JSON.stringify(rvList.slice(0,8)));
    }catch(e){}
  }
  var rvTarget=document.querySelector('[data-recently-viewed-target]');
  if(rvTarget){
    try{
      var rvStored=JSON.parse(localStorage.getItem('recentlyViewed')||'[]');
      var rvItems=rvStored.filter(function(p){return !rvCurrent||p.handle!==rvCurrent.handle;}).slice(0,4);
      if(rvItems.length){
        rvTarget.innerHTML=rvItems.map(function(p){
          return '<div class="pcard"><a href="'+escHtml(p.url)+'" class="pimg">'+(p.image?'<img src="'+escHtml(p.image)+'" alt="'+escHtml(p.title)+'" loading="lazy" width="500" height="500">':'')+'</a><div class="pbody"><h3><a href="'+escHtml(p.url)+'">'+escHtml(p.title)+'</a></h3><div class="pprice">'+escHtml(p.price)+'</div><a href="'+escHtml(p.url)+'" class="btn btn--primary">View product</a></div></div>';
        }).join('');
        var rvSection=rvTarget.closest('[data-recently-viewed-section]');
        if(rvSection)rvSection.hidden=false;
      }
    }catch(e){}
  }

  var eiPopup=document.getElementById('exitIntentPopup');
  if(eiPopup){
    function eiClose(){eiPopup.hidden=true;}
    eiPopup.querySelectorAll('[data-ei-close]').forEach(function(el){el.addEventListener('click',eiClose);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!eiPopup.hidden)eiClose();});
    document.addEventListener('mouseout',function(e){
      if(e.clientY>0)return;
      if(sessionStorage.getItem('exitIntentShown'))return;
      sessionStorage.setItem('exitIntentShown','true');
      eiPopup.hidden=false;
    });
  }

  document.querySelectorAll('[data-img-compare]').forEach(function(ic){
    var range=ic.querySelector('.ic-range');
    if(!range)return;
    range.addEventListener('input',function(){ic.style.setProperty('--pos',range.value+'%');});
  });

  var sel=document.getElementById('variant'), price=document.getElementById('price');
  if(sel&&price){sel.addEventListener('change',function(){var o=sel.options[sel.selectedIndex];if(o&&o.dataset.price){price.firstChild.nodeValue=o.dataset.price;}});}

  var storyModal=document.getElementById('storyModal');
  if(storyModal){
    function openStory(id){
      storyModal.querySelectorAll('.story-video').forEach(function(v){v.hidden=true;});
      var target=document.getElementById(id);
      if(target)target.hidden=false;
      storyModal.hidden=false;
      document.body.style.overflow='hidden';
    }
    function closeStory(){
      storyModal.hidden=true;
      document.body.style.overflow='';
      storyModal.querySelectorAll('iframe').forEach(function(f){f.src=f.src;});
    }
    document.querySelectorAll('[data-story-open]').forEach(function(btn){
      btn.addEventListener('click',function(){openStory(btn.getAttribute('data-story-open'));});
    });
    storyModal.querySelectorAll('[data-story-close]').forEach(function(el){el.addEventListener('click',closeStory);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!storyModal.hidden)closeStory();});
  }

  document.querySelectorAll('[data-glove-quiz]').forEach(function(q){
    var steps=q.querySelectorAll('[data-quiz-step]');
    var result=q.querySelector('[data-quiz-result]');
    var dots=q.querySelectorAll('[data-quiz-progress] .quiz-dot');
    var score={blue:0,black:0};
    function showStep(n){
      steps.forEach(function(s,i){s.hidden=i!==n;});
      if(result)result.hidden=true;
      dots.forEach(function(d,i){d.classList.toggle('is-active',i===n);});
    }
    steps.forEach(function(step,i){
      step.querySelectorAll('[data-quiz-value]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var v=btn.getAttribute('data-quiz-value');
          if(v==='blue')score.blue++;
          if(v==='black')score.black++;
          if(i+1<steps.length){showStep(i+1);return;}
          var winner=score.black>score.blue?'black':'blue';
          steps.forEach(function(s){s.hidden=true;});
          if(result){
            result.hidden=false;
            result.querySelectorAll('[data-quiz-panel]').forEach(function(p){p.hidden=p.getAttribute('data-quiz-panel')!==winner;});
          }
        });
      });
    });
    var retake=q.querySelector('[data-quiz-retake]');
    if(retake)retake.addEventListener('click',function(){score={blue:0,black:0};showStep(0);});
    showStep(0);
  });

  var headerPanels=document.querySelectorAll('[data-panel-toggle]');
  if(headerPanels.length){
    function closePanels(except){
      headerPanels.forEach(function(p){
        if(p===except)return;
        var btn=p.querySelector('.hicon-btn');
        var panel=p.querySelector('.hicon-panel, .hicon-search-form');
        if(panel){panel.hidden=true;}
        if(btn)btn.setAttribute('aria-expanded','false');
      });
    }
    headerPanels.forEach(function(wrap){
      var btn=wrap.querySelector('.hicon-btn');
      var panel=wrap.querySelector('.hicon-panel, .hicon-search-form');
      if(!btn||!panel)return;
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        var willOpen=panel.hidden;
        closePanels(wrap);
        panel.hidden=!willOpen;
        btn.setAttribute('aria-expanded',willOpen?'true':'false');
        if(willOpen){var input=panel.querySelector('input[type=search]');if(input)input.focus();}
      });
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest('[data-panel-toggle]'))closePanels();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closePanels();});
  }

  var stickyHeader=document.querySelector('[data-header]:not(.no-sticky)');
  if(stickyHeader){
    function onHeaderScroll(){stickyHeader.classList.toggle('is-stuck',window.scrollY>40);}
    window.addEventListener('scroll',onHeaderScroll,{passive:true});
    onHeaderScroll();
  }

  (function(){
    var WKEY='wishlist';
    function getWishlist(){try{return JSON.parse(localStorage.getItem(WKEY)||'[]');}catch(e){return [];}}
    function saveWishlist(list){localStorage.setItem(WKEY,JSON.stringify(list));}
    function updateWishlistUI(){
      var list=getWishlist();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
        var on=list.indexOf(btn.getAttribute('data-wishlist-toggle'))>-1;
        btn.classList.toggle('is-active',on);
        btn.setAttribute('aria-pressed',on?'true':'false');
      });
      document.querySelectorAll('[data-wishlist-count]').forEach(function(badge){
        badge.textContent=list.length;
        badge.hidden=list.length===0;
      });
    }
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-wishlist-toggle]');
      if(!btn)return;
      e.preventDefault();
      e.stopPropagation();
      var handle=btn.getAttribute('data-wishlist-toggle');
      var list=getWishlist();
      var idx=list.indexOf(handle);
      if(idx>-1){list.splice(idx,1);}else{list.push(handle);}
      saveWishlist(list);
      updateWishlistUI();
    });
    updateWishlistUI();
  })();

  document.querySelectorAll('[data-hp-video][data-disable-mobile="true"]').forEach(function(v){
    if(!window.matchMedia('(max-width:749px)').matches)return;
    v.pause();
    v.removeAttribute('src');
    v.querySelectorAll('source').forEach(function(s){s.remove();});
    v.load();
    v.style.display='none';
    if(v.poster){
      var img=document.createElement('img');
      img.src=v.poster;
      img.alt='';
      img.className='hero-pro-media';
      img.loading='eager';
      v.parentNode.insertBefore(img,v);
    }
  });
})();
